import { SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_600, SYS_SPACE_FIXED_800 } from '@oneaudi/unified-web-alpha-common';
import styled from 'styled-components';

export const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${SYS_SPACE_FIXED_800};
	padding: ${SYS_SPACE_FIXED_600};

	.buttons-container {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: ${SYS_SPACE_FIXED_100};
	}
`;
